import { Component, Input } from '@angular/core';
import { getBackLink } from '@core/jss-routing';
import { select, Store } from '@ngrx/store';
import type { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { GenericLinkDirective } from '@core/jss-utils';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import { TrackLinkDirective } from '@analytics/events';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { AsyncPipe } from '@angular/common';
import {
  ExperienceEditorComponent,
  ExperienceEditorLiveDirective,
  ExperienceEditorPreviewDirective,
} from '@core/experience-editor-components';

@Component({
  selector: 'wl-back-button-mobile',
  templateUrl: './back-button-mobile.component.html',
  styleUrls: [
    './back-button-mobile.component.ed.scss',
    './back-button-mobile.component.essent.scss',
  ],
  standalone: true,
  imports: [
    ExperienceEditorComponent,
    ExperienceEditorLiveDirective,
    ExperienceEditorPreviewDirective,
    GenericLinkDirective,
    AutomationIdDirective,
    CSCaptureDirective,
    TrackLinkDirective,
    FaIconComponent,
    AsyncPipe,
  ],
})
export class BackButtonMobileComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering: ComponentRendering | any;

  backLink$ = this.store$.pipe(select(getBackLink));

  constructor(private readonly store$: Store<any>) {}
}
